require('./angular-cookies');
module.exports = 'ngCookies';



//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-cookies/index.js
// module id = 230
// module chunks = 6